import apiOptimization from "../config/api_optimization";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiOptimization = axios.create({
//   baseURL: "http://localhost:8088",
// });

export function indexBoitelContract(payload) {
  const { groupId, farmId, page, sorter, filters, size, signal, ids } = payload;
  let sortS = "";
  if (sorter && Object.entries(sorter).length > 0) {
    const { field, order } = sorter;

    const fieldS = field
      ? field === "nextCommitmentDate"
        ? "next_commitment_date"
        : field
      : null;

    const orderS = order && order === "descend" ? "DESC" : "ASC";

    sortS = `&sort=${fieldS}&direction=${orderS}`;
  }

  return apiOptimization.post(
    `/bovexo/${groupId}/farms/${farmId}/contracts/boitels/list?${
      page ? `&page=${page - 1}` : ""
    }${size && `&size=${size}`}${sortS}${
      filters !== "" && filters ? `&search=${filters}` : ""
    }`,
    ids != null ? ids : null,
    getHeaders(false, signal)
  );
}

export function showBoitelContract(payload) {
  const { groupId, farmId, id, signal } = payload;
  return apiOptimization.get(
    `/bovexo/${groupId}/farms/${farmId}/contracts/boitels/${id}`,
    getHeaders(false, signal)
  );
}

export function storeBoitelContract(payload) {
  const { groupId, farmId, body, signal } = payload;
  return apiOptimization.post(
    `/bovexo/${groupId}/farms/${farmId}/contracts/boitels`,
    body,
    getHeaders(true, signal)
  );
}

export function updateBoitelContract(payload) {
  const { groupId, farmId, id, body, signal } = payload;
  if (id != null) {
    return apiOptimization.put(
      `/bovexo/${groupId}/farms/${farmId}/contracts/boitels/${id}`,
      body,
      getHeaders(false, signal)
    );
  } else {
    throw Error("Id parameter is required");
  }
}

export function deleteBoitelContract(payload) {
  const { groupId, farmId, id, signal } = payload;
  if (id != null) {
    return apiOptimization.delete(
      `/bovexo/${groupId}/farms/${farmId}/contracts/boitels/${id}`,
      getHeaders(false, signal)
    );
  } else {
    throw Error("Id parameter is required");
  }
}

export function saveBoitelContractAnimals(payload) {
  const { groupId, farmId, id, body, signal } = payload;
  if (id == null) {
    throw Error("Id parameter is required");
  }
  return apiOptimization.put(
    `/bovexo/${groupId}/farms/${farmId}/contracts/boitels/${id}/select-animals`,
    body,
    getHeaders(false, signal)
  );
}

